import { create } from "zustand";
import { getBearerToken, getUserIdFromSessionStorage, saveUserIdToSessionStorage, setBearerToken, setCurrentAccountId, } from "../../api/helpers/bearerToken";
import { redirectToSignIn } from "../../api/helpers/helpers";
import { getPacvueTokenFromLocalStorage, savePacvueTokenToLocalStorage, } from "../../api/helpers/pacvueTokenStore";
import { planGroups } from "../../common/consts/plans";
import { leitenRequest } from "../../leiten/controllers/leitenRequest";
import { ApiCheckLogin } from "../../requests/checkLogin";
import { ApiBearerToken } from "../../requests/getBearerToken";
import { ApiUpsell } from "../../requests/getUpsellInfo";
import { membersLink } from "../consts/links";
export const useCredentialsStore = create(() => ({
    main: { token: "", accountId: "", userId: "" },
    checkLogin: null,
    upsellInfo: null,
}));
/**
 * A function that handles token management for a given account.
 *
 * @param {Function} useCredentialsStore - A function that retrieves credentials information from a store.
 * @param {string} accountId - The ID of the account.
 * @returns {Promise<{ token: string, accountId: string }>} - A Promise that resolves to an object containing the token and account ID.
 */
export const useTokenController = leitenRequest(useCredentialsStore, "main", async (accountId) => {
    const existToken = await getBearerToken(accountId);
    const existingUserId = getUserIdFromSessionStorage();
    const existingPacvueToken = await getPacvueTokenFromLocalStorage(accountId);
    if (accountId && existToken && existingUserId) {
        setCurrentAccountId(accountId);
        return {
            token: existToken,
            accountId,
            userId: existingUserId,
            ...existingPacvueToken,
        };
    }
    else {
        const result = await ApiBearerToken.get(accountId);
        const { token, user: { id: h10UserId }, account: { id: h10AccountId }, pacvueToken, pacvueRefreshToken, pacvueTokenExpiresIn, } = result.data;
        return {
            token,
            accountId: String(h10AccountId),
            userId: String(h10UserId),
            pacvueToken,
            pacvueRefreshToken,
            pacvueTokenExpiresIn,
            pacvueTokenCreatedAt: Date.now(),
        };
    }
}, {
    fulfilled: ({ result: { token, accountId, userId, ...pacvueToken } }) => {
        setBearerToken(accountId, token);
        setCurrentAccountId(accountId);
        saveUserIdToSessionStorage(userId);
        savePacvueTokenToLocalStorage(accountId, pacvueToken);
    },
    rejected: ({ fetchError }) => {
        if (fetchError?.responseStatus === 401 ||
            (fetchError?.responseStatus !== 403 && window.location.hostname.includes("walmart"))) {
            redirectToSignIn();
        }
        else if (fetchError?.responseStatus === 403) {
            // TODO - redirect to 403 page and after delay redirect to member, like as PHP
            window.location.assign(membersLink);
        }
    },
});
export const useCheckLoginController = leitenRequest(useCredentialsStore, "checkLogin", (_) => ApiCheckLogin.get());
export const useUpsellInfoController = leitenRequest(useCredentialsStore, "upsellInfo", async (moduleId) => {
    return (await ApiUpsell.get({ moduleId })).results;
});
export const clearToken = () => {
    const accountId = useCredentialsStore.getState().main.accountId || "";
    setBearerToken(accountId, "");
    useTokenController.set({ token: "" });
};
export const loginPlanSelector = (state) => state.checkLogin?.basePlan
    ? planGroups[state.checkLogin.basePlan] || "free"
    : null;
export const isChineseSelector = (state) => !!state.upsellInfo?.isChinesePlans;
